import type { AppPlatform } from './ports';

/** Browser-safe fallback used by isolated component tests. Production entries inject a real host. */
export const noopAppPlatform: AppPlatform = {
  new: async () => false,
  open: async () => false,
  save: async () => undefined,
  saveAs: async () => undefined,
  exportTemplate: async () => undefined,
  createFromTemplate: async () => undefined,
  installLifecycle: () => () => undefined,
};
